module.exports = __webpack_public_path__ + "img/spaceman.7048d275.png";